module.exports = __webpack_public_path__ + "static/media/fixed_voice_dash_arrow_right.cf7cf345.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_dash_arrow_right.svg
// module id = 984
// module chunks = 0